import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { CurrencyProvider } from './hooks/useCurrency';
import { CountdownBanner } from './components/CountdownBanner';
import { OriginalLander } from './components/OriginalLander';
import { FacebookLander } from './components/FacebookLander';
import { CleanLander } from './components/CleanLander';
import { SalesPop } from './components/SalesPop';
export function App() {
  return <CurrencyProvider data-id="element-0">
      <CountdownBanner data-id="element-1" />
      <SalesPop data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<OriginalLander data-id="element-5" />} data-id="element-4" />
        <Route path="/lp2" element={<FacebookLander data-id="element-7" />} data-id="element-6" />
        <Route path="/lp3" element={<CleanLander data-id="element-9" />} data-id="element-8" />
      </Routes>
    </CurrencyProvider>;
}